import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import WarningIcon from '@mui/icons-material/Warning';
import TableCell from 'components/TableCell';
import Tooltip from '@mui/material/Tooltip';

import { PackageDateRowFlightPrice_flight$key } from '__generated__/PackageDateRowFlightPrice_flight.graphql';

type Props = {
  flight: PackageDateRowFlightPrice_flight$key | null;
};

const PackageDateRowFlightPrice: FC<Props> = props => {
  const flight = useFragment(
    graphql`
      fragment PackageDateRowFlightPrice_flight on Flight {
        priceLive
        isUpdating
      }
    `,
    props.flight
  );

  return (
    <TableCell center>
      {flight && (
        <>
          {!flight.isUpdating && (
            <Tooltip title="Nepavyksta atnaujinti kainos">
              <WarningIcon
                color="warning"
                fontSize="small"
                sx={{ display: 'inline-block', verticalAlign: 'middle', mr: 1 }}
              />
            </Tooltip>
          )}
          €{flight.priceLive}
        </>
      )}
    </TableCell>
  );
};

export default PackageDateRowFlightPrice;
